"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

var _jsxruntime = require('react/jsx-runtime');

var C = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "LockIconExtraSmall",
  size: "ExtraSmall",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    clipRule: "evenodd",
    d: "M9.71429 6.2H10.1429C10.6161 6.2 11 6.60313 11 7.1V10.7C11 11.1969 10.6161 11.6 10.1429 11.6H3.85714C3.38393 11.6 3 11.1969 3 10.7V7.1C3 6.60313 3.38393 6.2 3.85714 6.2H4.28571V4.85C4.28571 3.27875 5.50357 2 7 2C8.49643 2 9.71429 3.27875 9.71429 4.85V6.2ZM5.71445 4.85V6.2H8.28588V4.85C8.28588 4.10562 7.7091 3.5 7.00017 3.5C6.29124 3.5 5.71445 4.10562 5.71445 4.85Z",
    fillRule: "evenodd"
  }),
  svgElements: ["path"]
}),
    a = exports.b = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "LockIconSmall",
  size: "Small",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    clipRule: "evenodd",
    d: "M13.3929 8.25H13.9286C14.5201 8.25 15 8.75391 15 9.375V13.875C15 14.4961 14.5201 15 13.9286 15H6.07143C5.47991 15 5 14.4961 5 13.875V9.375C5 8.75391 5.47991 8.25 6.07143 8.25H6.60714V6.5625C6.60714 4.59844 8.12946 3 10 3C11.8705 3 13.3929 4.59844 13.3929 6.5625V8.25ZM8.39286 6.5625V8.25H11.6071V6.5625C11.6071 5.63203 10.8862 4.875 10 4.875C9.11384 4.875 8.39286 5.63203 8.39286 6.5625Z",
    fillRule: "evenodd"
  }),
  svgElements: ["path"]
});

exports.a = C;
exports.b = a;